/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import ListItemText from "@material-ui/core/ListItemText";
import Checkbox from "@material-ui/core/Checkbox";
import Chip from "@material-ui/core/Chip";

import StyledSelect from "./StyledSelect";
import StyledFormControl from "../common/StyledFormControl";
import styled from "styled-components";
import grey from "@material-ui/core/colors/grey";

const StyledChip = styled(Chip)`
  height: 15px !important;
  color: white !important;
  background-color: ${grey[700]} !important;
`;

const MultiSelect = ({
  handleChange,
  selectedValues,
  label,
  disabled,
  inputId,
  width,
  options,
  error,
}) => {
  return (
    <StyledFormControl
      variant="outlined"
      style={width ? { width } : {}}
      fullWidth={!width}
    >
      <InputLabel
        id={`${inputId}-label`}
        shrink={selectedValues.length > 0}
        style={{
          fontWeight: selectedValues.length > 0 ? 500 : 400,
        }}
      >
        {label}
      </InputLabel>
      <StyledSelect
        onChange={handleChange}
        value={selectedValues}
        labelId={`${inputId}-label`}
        disabled={disabled}
        label={label}
        error={error}
        multiple
        notched={selectedValues.length > 0}
        renderValue={(selected) => (
          <>
            {selected.map((val) => (
              <StyledChip
                key={`chip-${inputId}-${val}`}
                size="small"
                label={options.find((option) => option.id === val).title}
              />
            ))}
          </>
        )}
      >
        {options.map((val) => (
          <MenuItem key={`${inputId}-menu-${val.id}`} value={val.id}>
            <Checkbox
              checked={selectedValues.includes(val.id)}
              color="primary"
            />
            <ListItemText primary={val.title} />
          </MenuItem>
        ))}
      </StyledSelect>
    </StyledFormControl>
  );
};

export default MultiSelect;
